module.exports = __webpack_public_path__ + "static/media/modulo-gestao-servico.d09b534d.svg";